// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.QuickSettingsButton-module__font-s-10___r5uzf {
  font-size: 10px !important;
}

.QuickSettingsButton-module__font-s-12___gBXRL {
  font-size: 12px !important;
}

.QuickSettingsButton-module__font-s-13___ghREH {
  font-size: 13px !important;
}

.QuickSettingsButton-module__font-s-14___llYbl {
  font-size: 14px !important;
}

.QuickSettingsButton-module__font-s-15___guVV4 {
  font-size: 15px !important;
}

.QuickSettingsButton-module__font-s-16___drREB {
  font-size: 16px !important;
}

.QuickSettingsButton-module__font-s-18___kynji {
  font-size: 18px !important;
}

.QuickSettingsButton-module__font-s-20___UBh9n {
  font-size: 20px !important;
}

.QuickSettingsButton-module__font-s-22___hpEsv {
  font-size: 22px !important;
}

.QuickSettingsButton-module__font-s-28___juIaw {
  font-size: 28px !important;
}

.QuickSettingsButton-module__font-w-400___qJMxS {
  font-weight: 400 !important;
}

.QuickSettingsButton-module__font-w-500___IPb2E {
  font-weight: 500 !important;
}

.QuickSettingsButton-module__font-w-600___yceNg {
  font-weight: 600 !important;
}

.QuickSettingsButton-module__font-w-700___ciyLK {
  font-weight: 700 !important;
}

.QuickSettingsButton-module__p-5___yuLWs {
  padding: 5px !important;
}

.QuickSettingsButton-module__p-12___TVuVG {
  padding: 12px !important;
}

.QuickSettingsButton-module__p-16___Vs3EC {
  padding: 16px !important;
}

.QuickSettingsButton-module__p-30___AoFt5 {
  padding: 30px !important;
}

.QuickSettingsButton-module__p-b-0___FNWPd {
  padding-bottom: 0 !important;
}

.QuickSettingsButton-module__p-b-5___xgdMQ {
  padding-bottom: 5px !important;
}

.QuickSettingsButton-module__p-b-10___gIAUD {
  padding-bottom: 10px !important;
}

.QuickSettingsButton-module__p-b-12___XeQUi {
  padding-bottom: 12px !important;
}

.QuickSettingsButton-module__p-b-16___H7czG {
  padding-bottom: 16px !important;
}

.QuickSettingsButton-module__p-b-18___bKomg {
  padding-bottom: 18px !important;
}

.QuickSettingsButton-module__p-b-20___IHrPh {
  padding-bottom: 20px !important;
}

.QuickSettingsButton-module__p-b-25___I9crX {
  padding-bottom: 25px !important;
}

.QuickSettingsButton-module__p-b-30____8srd {
  padding-bottom: 30px !important;
}

.QuickSettingsButton-module__p-b-50___wA_T8 {
  padding-bottom: 50px !important;
}

.QuickSettingsButton-module__p-t-0___tkr6o {
  padding-top: 0 !important;
}

.QuickSettingsButton-module__p-t-12___cry5H {
  padding-top: 12px !important;
}

.QuickSettingsButton-module__p-t-16___Vao1Z {
  padding-top: 16px !important;
}

.QuickSettingsButton-module__p-t-18___oh14j {
  padding-top: 18px !important;
}

.QuickSettingsButton-module__p-t-20___Dd7qp {
  padding-top: 20px !important;
}

.QuickSettingsButton-module__p-t-30___z4XR4 {
  padding-top: 30px !important;
}

.QuickSettingsButton-module__p-t-40___Gq7wl {
  padding-top: 40px !important;
}

.QuickSettingsButton-module__p-t-50___u6ZJf {
  padding-top: 50px !important;
}

.QuickSettingsButton-module__p-l-20___xfKBB {
  padding-left: 20px !important;
}

.QuickSettingsButton-module__p-l-30____OQq1 {
  padding-left: 30px !important;
}

.QuickSettingsButton-module__p-l-40____WzqD {
  padding-left: 40px !important;
}

.QuickSettingsButton-module__p-r-16___U4iLh {
  padding-right: 16px !important;
}

.QuickSettingsButton-module__p-r-20___p72wr {
  padding-right: 20px !important;
}

.QuickSettingsButton-module__p-r-30___nK0Em {
  padding-right: 30px !important;
}

.QuickSettingsButton-module__p-r-50___Tr_ZC {
  padding-right: 50px !important;
}

.QuickSettingsButton-module__p-r-60___N53Ln {
  padding-right: 60px !important;
}

.QuickSettingsButton-module__m-b-1___NHIQV {
  margin-bottom: 1px !important;
}

.QuickSettingsButton-module__m-b-2___sbUHF {
  margin-bottom: 2px !important;
}

.QuickSettingsButton-module__m-b-6___M3IXz {
  margin-bottom: 6px !important;
}

.QuickSettingsButton-module__m-b-8___l5VMT {
  margin-bottom: 8px !important;
}

.QuickSettingsButton-module__m-b-10___H3Owc {
  margin-bottom: 10px !important;
}

.QuickSettingsButton-module__m-b-14___HU4Rb {
  margin-bottom: 14px !important;
}

.QuickSettingsButton-module__m-b-16___NEEeR {
  margin-bottom: 16px !important;
}

.QuickSettingsButton-module__m-b-20___SbejP {
  margin-bottom: 20px !important;
}

.QuickSettingsButton-module__m-b-22___NGeTY {
  margin-bottom: 22px !important;
}

.QuickSettingsButton-module__m-b-24___opwkT {
  margin-bottom: 24px !important;
}

.QuickSettingsButton-module__m-b-30___mqCZo {
  margin-bottom: 30px !important;
}

.QuickSettingsButton-module__m-b-32___BRijQ {
  margin-bottom: 32px !important;
}

.QuickSettingsButton-module__m-b-40___lSrgo {
  margin-bottom: 40px !important;
}

.QuickSettingsButton-module__m-t-2___qMLfk {
  margin-top: 2px !important;
}

.QuickSettingsButton-module__m-t-3___uXmnd {
  margin-top: 3px !important;
}

.QuickSettingsButton-module__m-t-4___ngIDy {
  margin-top: 4px !important;
}

.QuickSettingsButton-module__m-t-5___ElWqg {
  margin-top: 5px !important;
}

.QuickSettingsButton-module__m-t-8___odL2u {
  margin-top: 8px !important;
}

.QuickSettingsButton-module__m-t-10___tE2v_ {
  margin-top: 10px !important;
}

.QuickSettingsButton-module__m-t-15___hkiAO {
  margin-top: 15px !important;
}

.QuickSettingsButton-module__m-t-16___dv_F1 {
  margin-top: 16px !important;
}

.QuickSettingsButton-module__m-t-20___qj9u_ {
  margin-top: 20px !important;
}

.QuickSettingsButton-module__m-t-22___AfMPI {
  margin-top: 22px !important;
}

.QuickSettingsButton-module__m-t-30___PEMz5 {
  margin-top: 30px !important;
}

.QuickSettingsButton-module__m-t-32___uuoDM {
  margin-top: 32px !important;
}

.QuickSettingsButton-module__m-l-auto___K3ZkE {
  margin-left: auto !important;
}

.QuickSettingsButton-module__m-l-4___VIkEP {
  margin-left: 4px !important;
}

.QuickSettingsButton-module__m-l-5___d1Tbp {
  margin-left: 5px !important;
}

.QuickSettingsButton-module__m-l-6___hOE1K {
  margin-left: 6px !important;
}

.QuickSettingsButton-module__m-l-8___yXGJl {
  margin-left: 8px !important;
}

.QuickSettingsButton-module__m-l-10___IVW4D {
  margin-left: 10px !important;
}

.QuickSettingsButton-module__m-l-16___znfve {
  margin-left: 16px !important;
}

.QuickSettingsButton-module__m-l-20___O8CxT {
  margin-left: 20px !important;
}

.QuickSettingsButton-module__m-l-24____m1wH {
  margin-left: 24px !important;
}

.QuickSettingsButton-module__m-l-30___YDEdX {
  margin-left: 30px !important;
}

.QuickSettingsButton-module__m-l-35___TcjWa {
  margin-left: 35px !important;
}

.QuickSettingsButton-module__m-l-40___rnmoY {
  margin-left: 40px !important;
}

.QuickSettingsButton-module__m-r-8___kH7J_ {
  margin-right: 8px !important;
}

.QuickSettingsButton-module__m-r-10___sDsLR {
  margin-right: 10px !important;
}

.QuickSettingsButton-module__m-r-16___yGzHv {
  margin-right: 16px !important;
}

.QuickSettingsButton-module__m-r-20___rb93I {
  margin-right: 20px !important;
}

.QuickSettingsButton-module__m-r-24___o4vDo {
  margin-right: 24px !important;
}

.QuickSettingsButton-module__m-r-30___aCSLW {
  margin-right: 30px !important;
}

.QuickSettingsButton-module__m-r-40___swMvI {
  margin-right: 40px !important;
}

.QuickSettingsButton-module__border-r-3___E96Fe {
  border-radius: 3px !important;
}

.QuickSettingsButton-module__border-r-4___HsTaG {
  border-radius: 4px !important;
}

.QuickSettingsButton-module__border-r-6___WIIMG {
  border-radius: 6px !important;
}

.QuickSettingsButton-module__border-r-10___tJ_E3 {
  border-radius: 10px !important;
}

.QuickSettingsButton-module__border-r-12___sRfqS {
  border-radius: 12px !important;
}

.QuickSettingsButton-module__border-r-16___zk9qm {
  border-radius: 16px !important;
}

.QuickSettingsButton-module__border-r-50___CDsxB {
  border-radius: 50% !important;
}

.QuickSettingsButton-module__primary-border___ik_F1 {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.QuickSettingsButton-module__primary-border-b___XwEMB {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.QuickSettingsButton-module__primary-border-t___hkyN1 {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.QuickSettingsButton-module__primary-border-l___Jcth5 {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.QuickSettingsButton-module__primary-border-r___DSHmq {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.QuickSettingsButton-module__secondary-border___n8mz4 {
  border: 1px solid #637768;
}

.QuickSettingsButton-module__secondary-border-b___YlG6p {
  border-bottom: 1px solid #637768;
}

.QuickSettingsButton-module__secondary-border-t___pRZKn {
  border-top: 1px solid #637768;
}

.QuickSettingsButton-module__secondary-border-l___rrLaD {
  border-left: 1px solid #637768;
}

.QuickSettingsButton-module__secondary-border-r___qsMku {
  border-right: 1px solid #637768;
}

.QuickSettingsButton-module__gap-0___QWTMK {
  gap: 0 !important;
}

.QuickSettingsButton-module__gap-2___t3f_J {
  gap: 2px !important;
}

.QuickSettingsButton-module__gap-4___q64W4 {
  gap: 4px !important;
}

.QuickSettingsButton-module__gap-5___FMM2c {
  gap: 5px !important;
}

.QuickSettingsButton-module__gap-6___UvjI2 {
  gap: 6px !important;
}

.QuickSettingsButton-module__gap-8___h54jQ {
  gap: 8px !important;
}

.QuickSettingsButton-module__gap-10___QU5r5 {
  gap: 10px !important;
}

.QuickSettingsButton-module__gap-12___SDv5n {
  gap: 12px !important;
}

.QuickSettingsButton-module__gap-14___KdUWv {
  gap: 14px !important;
}

.QuickSettingsButton-module__gap-16___jwJlb {
  gap: 16px !important;
}

.QuickSettingsButton-module__gap-18___czUKE {
  gap: 18px !important;
}

.QuickSettingsButton-module__gap-20___zWFyc {
  gap: 20px !important;
}

.QuickSettingsButton-module__gap-24___OVTnW {
  gap: 24px !important;
}

.QuickSettingsButton-module__gap-26___qzNMb {
  gap: 26px !important;
}

.QuickSettingsButton-module__gap-30___TfExr {
  gap: 30px !important;
}

.QuickSettingsButton-module__gap-32___z2lZi {
  gap: 32px !important;
}

.QuickSettingsButton-module__gap-40___HaVXo {
  gap: 40px !important;
}

.QuickSettingsButton-module__gap-50___Z9PGU {
  gap: 50px !important;
}

.QuickSettingsButton-module__flex-1___m5laX {
  flex: 1;
}

.QuickSettingsButton-module__flex-none___gBW43 {
  flex: none !important;
}

.QuickSettingsButton-module__flex-column___ChCps {
  display: flex;
  flex-direction: column !important;
}

.QuickSettingsButton-module__flex-row___gMdej {
  display: flex;
  flex-direction: row !important;
}

.QuickSettingsButton-module__vertically-centered___H1CCN {
  display: flex;
  align-items: center !important;
}

.QuickSettingsButton-module__horizontally-centered___qVi9e {
  display: flex;
  justify-content: center !important;
}

.QuickSettingsButton-module__horizontally-end___DKj0Y {
  display: flex;
  justify-content: end !important;
}

.QuickSettingsButton-module__vertically-start___SfR9H {
  display: flex;
  align-items: start !important;
}

.QuickSettingsButton-module__space-between___ZdHhP {
  display: flex;
  justify-content: space-between !important;
}

.QuickSettingsButton-module__flex-wrap___h3C3B {
  flex-wrap: wrap !important;
}

.QuickSettingsButton-module__height-100___HX8yD {
  height: 100%;
}

.QuickSettingsButton-module__width-50___x0P8k {
  width: 50% !important;
}

.QuickSettingsButton-module__width-100___KqG44 {
  width: 100%;
}

.QuickSettingsButton-module__cursor-pointer___VVkhi {
  cursor: pointer;
}

.QuickSettingsButton-module__cursor-not-allowed___eBAi7 {
  cursor: not-allowed !important;
}

.QuickSettingsButton-module__absolute-centered___Qs_V1 {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.QuickSettingsButton-module__absolute___VjEfW {
  position: absolute;
}

.QuickSettingsButton-module__relative____0I8W {
  position: relative;
}

.QuickSettingsButton-module__fixed___GaELv {
  position: fixed;
}

.QuickSettingsButton-module__visible___GUB4O {
  opacity: 1;
}

.QuickSettingsButton-module__invisible___fgVE5 {
  opacity: 0;
}

.QuickSettingsButton-module__col-90___jBNGH {
  width: 90% !important;
}

.QuickSettingsButton-module__col-auto___tNdwm {
  width: auto !important;
}

.QuickSettingsButton-module__medical-tabs___szZj3 {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.QuickSettingsButton-module__medical-table-new___mrzwc {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.QuickSettingsButton-module__medical-table-new___mrzwc:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.QuickSettingsButton-module__medical-table-new___mrzwc::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.QuickSettingsButton-module__medical-table-new___mrzwc::-webkit-scrollbar-track {
  display: none;
}
.QuickSettingsButton-module__medical-table-new___mrzwc.QuickSettingsButton-module__no-pagination___K1_4d {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.QuickSettingsButton-module__medical-table-new___mrzwc.QuickSettingsButton-module__no-pagination___K1_4d:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.QuickSettingsButton-module__medical-table-new___mrzwc.QuickSettingsButton-module__no-pagination___K1_4d::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.QuickSettingsButton-module__medical-table-new___mrzwc.QuickSettingsButton-module__no-pagination___K1_4d::-webkit-scrollbar-track {
  display: none;
}

.QuickSettingsButton-module__medical-table-empty___J31UJ {
  padding: 14px 40px !important;
}

.QuickSettingsButton-module__icon-btn___COiJP {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.QuickSettingsButton-module__search-icon___QmFsH {
  width: 24px;
  height: 24px;
  align-self: center;
}

.QuickSettingsButton-module__disable-select___C_wPZ {
  user-select: none;
}

.QuickSettingsButton-module__break-word___RNaGX {
  word-break: break-word;
}

.QuickSettingsButton-module__popup-clear-btn___LoM4Q {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.QuickSettingsButton-module__scroll-m-b-20___ckRLQ {
  scroll-margin-bottom: 20px;
}

.QuickSettingsButton-module__container___t2ZKi {
  margin-left: auto;
}
.QuickSettingsButton-module__container___t2ZKi .QuickSettingsButton-module__button___CDqSj {
  padding: 5px 10px;
  margin-left: -14px;
  gap: 4px !important;
  justify-content: flex-start !important;
  user-select: none;
}
.QuickSettingsButton-module__container___t2ZKi .QuickSettingsButton-module__button___CDqSj > img {
  width: 20px;
  height: 20px;
}
.QuickSettingsButton-module__container___t2ZKi .QuickSettingsButton-module__button___CDqSj > span {
  font-size: 14px !important;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/components/navigation/MainFooter/QuickSettingsButton/QuickSettingsButton.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,iBAAA;AA8pBF;AA5pBE;EACE,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,sCAAA;EACA,iBAAA;AA8pBJ;AA5pBI;EACE,WAAA;EACA,YAAA;AA8pBN;AA3pBI;EACE,0BAAA;AA6pBN","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.container {\n  margin-left: auto;\n\n  .button {\n    padding: 5px 10px;\n    margin-left: -14px;\n    gap: 4px !important;\n    justify-content: flex-start !important;\n    user-select: none;\n\n    & > img {\n      width: 20px;\n      height: 20px;\n    }\n\n    & > span {\n      font-size: 14px !important;\n    }\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `QuickSettingsButton-module__font-s-10___r5uzf`,
	"fontS12": `QuickSettingsButton-module__font-s-12___gBXRL`,
	"fontS13": `QuickSettingsButton-module__font-s-13___ghREH`,
	"fontS14": `QuickSettingsButton-module__font-s-14___llYbl`,
	"fontS15": `QuickSettingsButton-module__font-s-15___guVV4`,
	"fontS16": `QuickSettingsButton-module__font-s-16___drREB`,
	"fontS18": `QuickSettingsButton-module__font-s-18___kynji`,
	"fontS20": `QuickSettingsButton-module__font-s-20___UBh9n`,
	"fontS22": `QuickSettingsButton-module__font-s-22___hpEsv`,
	"fontS28": `QuickSettingsButton-module__font-s-28___juIaw`,
	"fontW400": `QuickSettingsButton-module__font-w-400___qJMxS`,
	"fontW500": `QuickSettingsButton-module__font-w-500___IPb2E`,
	"fontW600": `QuickSettingsButton-module__font-w-600___yceNg`,
	"fontW700": `QuickSettingsButton-module__font-w-700___ciyLK`,
	"p5": `QuickSettingsButton-module__p-5___yuLWs`,
	"p12": `QuickSettingsButton-module__p-12___TVuVG`,
	"p16": `QuickSettingsButton-module__p-16___Vs3EC`,
	"p30": `QuickSettingsButton-module__p-30___AoFt5`,
	"pB0": `QuickSettingsButton-module__p-b-0___FNWPd`,
	"pB5": `QuickSettingsButton-module__p-b-5___xgdMQ`,
	"pB10": `QuickSettingsButton-module__p-b-10___gIAUD`,
	"pB12": `QuickSettingsButton-module__p-b-12___XeQUi`,
	"pB16": `QuickSettingsButton-module__p-b-16___H7czG`,
	"pB18": `QuickSettingsButton-module__p-b-18___bKomg`,
	"pB20": `QuickSettingsButton-module__p-b-20___IHrPh`,
	"pB25": `QuickSettingsButton-module__p-b-25___I9crX`,
	"pB30": `QuickSettingsButton-module__p-b-30____8srd`,
	"pB50": `QuickSettingsButton-module__p-b-50___wA_T8`,
	"pT0": `QuickSettingsButton-module__p-t-0___tkr6o`,
	"pT12": `QuickSettingsButton-module__p-t-12___cry5H`,
	"pT16": `QuickSettingsButton-module__p-t-16___Vao1Z`,
	"pT18": `QuickSettingsButton-module__p-t-18___oh14j`,
	"pT20": `QuickSettingsButton-module__p-t-20___Dd7qp`,
	"pT30": `QuickSettingsButton-module__p-t-30___z4XR4`,
	"pT40": `QuickSettingsButton-module__p-t-40___Gq7wl`,
	"pT50": `QuickSettingsButton-module__p-t-50___u6ZJf`,
	"pL20": `QuickSettingsButton-module__p-l-20___xfKBB`,
	"pL30": `QuickSettingsButton-module__p-l-30____OQq1`,
	"pL40": `QuickSettingsButton-module__p-l-40____WzqD`,
	"pR16": `QuickSettingsButton-module__p-r-16___U4iLh`,
	"pR20": `QuickSettingsButton-module__p-r-20___p72wr`,
	"pR30": `QuickSettingsButton-module__p-r-30___nK0Em`,
	"pR50": `QuickSettingsButton-module__p-r-50___Tr_ZC`,
	"pR60": `QuickSettingsButton-module__p-r-60___N53Ln`,
	"mB1": `QuickSettingsButton-module__m-b-1___NHIQV`,
	"mB2": `QuickSettingsButton-module__m-b-2___sbUHF`,
	"mB6": `QuickSettingsButton-module__m-b-6___M3IXz`,
	"mB8": `QuickSettingsButton-module__m-b-8___l5VMT`,
	"mB10": `QuickSettingsButton-module__m-b-10___H3Owc`,
	"mB14": `QuickSettingsButton-module__m-b-14___HU4Rb`,
	"mB16": `QuickSettingsButton-module__m-b-16___NEEeR`,
	"mB20": `QuickSettingsButton-module__m-b-20___SbejP`,
	"mB22": `QuickSettingsButton-module__m-b-22___NGeTY`,
	"mB24": `QuickSettingsButton-module__m-b-24___opwkT`,
	"mB30": `QuickSettingsButton-module__m-b-30___mqCZo`,
	"mB32": `QuickSettingsButton-module__m-b-32___BRijQ`,
	"mB40": `QuickSettingsButton-module__m-b-40___lSrgo`,
	"mT2": `QuickSettingsButton-module__m-t-2___qMLfk`,
	"mT3": `QuickSettingsButton-module__m-t-3___uXmnd`,
	"mT4": `QuickSettingsButton-module__m-t-4___ngIDy`,
	"mT5": `QuickSettingsButton-module__m-t-5___ElWqg`,
	"mT8": `QuickSettingsButton-module__m-t-8___odL2u`,
	"mT10": `QuickSettingsButton-module__m-t-10___tE2v_`,
	"mT15": `QuickSettingsButton-module__m-t-15___hkiAO`,
	"mT16": `QuickSettingsButton-module__m-t-16___dv_F1`,
	"mT20": `QuickSettingsButton-module__m-t-20___qj9u_`,
	"mT22": `QuickSettingsButton-module__m-t-22___AfMPI`,
	"mT30": `QuickSettingsButton-module__m-t-30___PEMz5`,
	"mT32": `QuickSettingsButton-module__m-t-32___uuoDM`,
	"mLAuto": `QuickSettingsButton-module__m-l-auto___K3ZkE`,
	"mL4": `QuickSettingsButton-module__m-l-4___VIkEP`,
	"mL5": `QuickSettingsButton-module__m-l-5___d1Tbp`,
	"mL6": `QuickSettingsButton-module__m-l-6___hOE1K`,
	"mL8": `QuickSettingsButton-module__m-l-8___yXGJl`,
	"mL10": `QuickSettingsButton-module__m-l-10___IVW4D`,
	"mL16": `QuickSettingsButton-module__m-l-16___znfve`,
	"mL20": `QuickSettingsButton-module__m-l-20___O8CxT`,
	"mL24": `QuickSettingsButton-module__m-l-24____m1wH`,
	"mL30": `QuickSettingsButton-module__m-l-30___YDEdX`,
	"mL35": `QuickSettingsButton-module__m-l-35___TcjWa`,
	"mL40": `QuickSettingsButton-module__m-l-40___rnmoY`,
	"mR8": `QuickSettingsButton-module__m-r-8___kH7J_`,
	"mR10": `QuickSettingsButton-module__m-r-10___sDsLR`,
	"mR16": `QuickSettingsButton-module__m-r-16___yGzHv`,
	"mR20": `QuickSettingsButton-module__m-r-20___rb93I`,
	"mR24": `QuickSettingsButton-module__m-r-24___o4vDo`,
	"mR30": `QuickSettingsButton-module__m-r-30___aCSLW`,
	"mR40": `QuickSettingsButton-module__m-r-40___swMvI`,
	"borderR3": `QuickSettingsButton-module__border-r-3___E96Fe`,
	"borderR4": `QuickSettingsButton-module__border-r-4___HsTaG`,
	"borderR6": `QuickSettingsButton-module__border-r-6___WIIMG`,
	"borderR10": `QuickSettingsButton-module__border-r-10___tJ_E3`,
	"borderR12": `QuickSettingsButton-module__border-r-12___sRfqS`,
	"borderR16": `QuickSettingsButton-module__border-r-16___zk9qm`,
	"borderR50": `QuickSettingsButton-module__border-r-50___CDsxB`,
	"primaryBorder": `QuickSettingsButton-module__primary-border___ik_F1`,
	"primaryBorderB": `QuickSettingsButton-module__primary-border-b___XwEMB`,
	"primaryBorderT": `QuickSettingsButton-module__primary-border-t___hkyN1`,
	"primaryBorderL": `QuickSettingsButton-module__primary-border-l___Jcth5`,
	"primaryBorderR": `QuickSettingsButton-module__primary-border-r___DSHmq`,
	"secondaryBorder": `QuickSettingsButton-module__secondary-border___n8mz4`,
	"secondaryBorderB": `QuickSettingsButton-module__secondary-border-b___YlG6p`,
	"secondaryBorderT": `QuickSettingsButton-module__secondary-border-t___pRZKn`,
	"secondaryBorderL": `QuickSettingsButton-module__secondary-border-l___rrLaD`,
	"secondaryBorderR": `QuickSettingsButton-module__secondary-border-r___qsMku`,
	"gap0": `QuickSettingsButton-module__gap-0___QWTMK`,
	"gap2": `QuickSettingsButton-module__gap-2___t3f_J`,
	"gap4": `QuickSettingsButton-module__gap-4___q64W4`,
	"gap5": `QuickSettingsButton-module__gap-5___FMM2c`,
	"gap6": `QuickSettingsButton-module__gap-6___UvjI2`,
	"gap8": `QuickSettingsButton-module__gap-8___h54jQ`,
	"gap10": `QuickSettingsButton-module__gap-10___QU5r5`,
	"gap12": `QuickSettingsButton-module__gap-12___SDv5n`,
	"gap14": `QuickSettingsButton-module__gap-14___KdUWv`,
	"gap16": `QuickSettingsButton-module__gap-16___jwJlb`,
	"gap18": `QuickSettingsButton-module__gap-18___czUKE`,
	"gap20": `QuickSettingsButton-module__gap-20___zWFyc`,
	"gap24": `QuickSettingsButton-module__gap-24___OVTnW`,
	"gap26": `QuickSettingsButton-module__gap-26___qzNMb`,
	"gap30": `QuickSettingsButton-module__gap-30___TfExr`,
	"gap32": `QuickSettingsButton-module__gap-32___z2lZi`,
	"gap40": `QuickSettingsButton-module__gap-40___HaVXo`,
	"gap50": `QuickSettingsButton-module__gap-50___Z9PGU`,
	"flex1": `QuickSettingsButton-module__flex-1___m5laX`,
	"flexNone": `QuickSettingsButton-module__flex-none___gBW43`,
	"flexColumn": `QuickSettingsButton-module__flex-column___ChCps`,
	"flexRow": `QuickSettingsButton-module__flex-row___gMdej`,
	"verticallyCentered": `QuickSettingsButton-module__vertically-centered___H1CCN`,
	"horizontallyCentered": `QuickSettingsButton-module__horizontally-centered___qVi9e`,
	"horizontallyEnd": `QuickSettingsButton-module__horizontally-end___DKj0Y`,
	"verticallyStart": `QuickSettingsButton-module__vertically-start___SfR9H`,
	"spaceBetween": `QuickSettingsButton-module__space-between___ZdHhP`,
	"flexWrap": `QuickSettingsButton-module__flex-wrap___h3C3B`,
	"height100": `QuickSettingsButton-module__height-100___HX8yD`,
	"width50": `QuickSettingsButton-module__width-50___x0P8k`,
	"width100": `QuickSettingsButton-module__width-100___KqG44`,
	"cursorPointer": `QuickSettingsButton-module__cursor-pointer___VVkhi`,
	"cursorNotAllowed": `QuickSettingsButton-module__cursor-not-allowed___eBAi7`,
	"absoluteCentered": `QuickSettingsButton-module__absolute-centered___Qs_V1`,
	"absolute": `QuickSettingsButton-module__absolute___VjEfW`,
	"relative": `QuickSettingsButton-module__relative____0I8W`,
	"fixed": `QuickSettingsButton-module__fixed___GaELv`,
	"visible": `QuickSettingsButton-module__visible___GUB4O`,
	"invisible": `QuickSettingsButton-module__invisible___fgVE5`,
	"col90": `QuickSettingsButton-module__col-90___jBNGH`,
	"colAuto": `QuickSettingsButton-module__col-auto___tNdwm`,
	"medicalTabs": `QuickSettingsButton-module__medical-tabs___szZj3`,
	"medicalTableNew": `QuickSettingsButton-module__medical-table-new___mrzwc`,
	"noPagination": `QuickSettingsButton-module__no-pagination___K1_4d`,
	"medicalTableEmpty": `QuickSettingsButton-module__medical-table-empty___J31UJ`,
	"iconBtn": `QuickSettingsButton-module__icon-btn___COiJP`,
	"searchIcon": `QuickSettingsButton-module__search-icon___QmFsH`,
	"disableSelect": `QuickSettingsButton-module__disable-select___C_wPZ`,
	"breakWord": `QuickSettingsButton-module__break-word___RNaGX`,
	"popupClearBtn": `QuickSettingsButton-module__popup-clear-btn___LoM4Q`,
	"scrollMB20": `QuickSettingsButton-module__scroll-m-b-20___ckRLQ`,
	"container": `QuickSettingsButton-module__container___t2ZKi`,
	"button": `QuickSettingsButton-module__button___CDqSj`
};
module.exports = ___CSS_LOADER_EXPORT___;
